import {get} from './fetch'

import {camelCaseObjectKeys, onStatus, shimJson} from './helpers'
import SERVICES from '../config/services'

export const getParticipantInfo = (token) =>
  get(`${SERVICES.TBT_API_URL}/users/token/${token}`).then(
    onStatus({
      OK: shimJson(camelCaseObjectKeys),
    }),
  )
